// extracted by mini-css-extract-plugin
export default {"release-notes-collapsible":"w_b3","header-collapsible":"w_b4"};